import React from 'react';
import { XIcon } from 'lucide-react';
import { useSearchParams } from 'react-router';
import { Button } from '@/components/ui/button';
import { useAssetImportBatch } from 'hooks/assetImports/assetImportHooks';
import {
  importBannerMessage,
  importSourceLabel,
} from 'hooks/assetImports/assetImportLabels';
import { UndoAssetImportButton } from './AssetImportProvenance';

const IMPORT_BATCH_PARAM = 'importBatch';

/** Shown when PRATUS AI links here after an import (`?importBatch=<id>`). */
export function AssetImportBanner() {
  const [searchParams, setSearchParams] = useSearchParams();
  const batchId = searchParams.get(IMPORT_BATCH_PARAM);
  const { data: batch } = useAssetImportBatch(batchId);

  const dismiss = () => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(IMPORT_BATCH_PARAM);
        return next;
      },
      { replace: true }
    );
  };

  if (!batchId || !batch || batch.status === 'drafted') return null;

  return (
    <div
      role="status"
      data-testid="asset-import-banner"
      className="tw:my-2 tw:flex tw:flex-wrap tw:items-center tw:justify-between tw:gap-2 tw:rounded-md tw:border tw:border-info/40 tw:bg-info/10 tw:px-3 tw:py-2 tw:text-sm tw:text-foreground"
    >
      <span>{importBannerMessage(batch)}</span>
      <div className="tw:flex tw:items-center tw:gap-1">
        {batch.status === 'committed' && batch.created > 0 && (
          <UndoAssetImportButton
            batchId={batch.id}
            sourceLabel={importSourceLabel(batch)}
            createdCount={batch.created}
          />
        )}
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label="Dismiss"
          onClick={dismiss}
        >
          <XIcon />
        </Button>
      </div>
    </div>
  );
}
